<template>
  <div id="app">
    <luanch v-if="token && showLuanch && !isShake"></luanch>
    <!-- <router-view @notify="onNotify" @setShare="setShare" /> -->
    <!-- vue实现返回上一页面，页面停留在原来位置，不刷新 -->
    <keep-alive>
      <router-view
        :key="$route.fullPath"
        v-if="$route.meta.keepAlive"
        @notify="onNotify">
      </router-view>
    </keep-alive>
    <router-view
      :key="$route.fullPath"
      v-if="!$route.meta.keepAlive"
      @notify="onNotify"></router-view>
    <tian-tabbar v-if="showTabbar" />
    <ratecoupon-pop
      :visible.sync="showRateCouponPop"
      :params="rateCouponParams"
      @close="showRateCouponPop = false"
      @commitUse="onGetRateCoupon" />
    <!-- 反诈骗弹屏信息   -->
    <van-popup
      class="ad-dialog"
      style="width: 100vw; background-color: transparent"
      :close-on-click-overlay="false"
      v-model="adShow">
      <div class="ta-c mt-15">
        <van-icon
          style="position: absolute; right: 15%; top: 0"
          name="close"
          size="25"
          color="white"
          @click="adShow = false" />
        <img style="width: 70%; height: auto" :src="imgPath" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import tianTabbar from "@/view/tabbar/index"
import { Dialog, Icon, Notify, Popup } from "vant"
import { mapMutations, mapGetters, mapActions } from "vuex"
import * as CustApi from "@/api/cust"
import * as PayApi from "@/api/pay"
import * as ShareConfig from "@/utils/shareConfig"
import * as LuanchApi from "@/api/luanch"
import luanch from "@/view/luanch/index"
import session from "./utils/session"
import { authorize } from "./assets/js/authorize"
import { mayNoticed } from "./api/lottery"
import { getCustNotice } from "./api/cust"
import RatecouponPop from "./view/home/components/ratecouponPop.vue"
import { bulletin } from "./api/home"
export default {
  name: "App",
  data() {
    return {
      isShake: false,
      showTabbar: false,

      showRateCouponPop: false,
      rateCouponParams: {
        id: "",
        amount: 0.2,
        unit: "%",
        content: "60天及以上资产",
        content1: "可使用",
        isInterest: true // 是否起息
      },
      adShow: false,
      imgPath: ""
    }
  },

  beforeMount() {
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //判断是否是微信环境
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram == true) {
          this.setOs("mini")
        } else {
          this.setOs("wx")
        }
      })
    } else {
      if (window.plus) {
        this.plusReady()
      } else {
        document.addEventListener("plusready", this.plusReady, false)
      }
    }
  },
  mounted() {
    let url = location.href.split("#")[0]
    ShareConfig.getJSSDK(url, this.$store.state.share.shareOriginData)

    window.addEventListener("hashchange", () => {
      let currentPath = location.href.split("#")[1]
      if (currentPath.indexOf(this.$route.path) < 0) {
        this.$router.push(currentPath)
      }
    })

    window.onload = function () {
      session.del("listBanner")
      session.del("notifies")
    }

    window.onerror = function (msg, source, line, column, error) {
      console.log(
        "捕获全局window对象抛出js异常：msg == %O, source == %O, line == %O, column == %O, error == %O",
        msg,
        source,
        line,
        column,
        error
      )
    }

    /**
     * H5页面隐藏到后台、息屏执行时间、微信浏览器，页面可见性事件visibilitychange
     */
    /*
    window.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        // 用户息屏、或者切到后台运行 （离开页面）
        console.log("页面不可见")
        alert("11111")
      } else if (document.visibilityState === "visible") {
        // 用户打开或回到页面
        console.log("页面可见")
        alert("222222")
      }
    })*/
  },

  watch: {
    $route(to) {
      const arrName = ["home", "user", "invest", "news"]
      this.showTabbar = false
      arrName.forEach((el) => {
        if (to.name === el) this.showTabbar = true
      })
      if (
        (to.path == "/shake" && to.query.isMenu == "true") ||
        to.query.redirect == "/shake?isMenu=true"
      ) {
        this.isShake = true
      }
      /**
       * title: "天安金交中心",
          desc: "您身边的财富管家",
          link: window.location.href
       */
      this.$store.state.share.shareOriginData.title = "天安金交中心"
      this.$store.state.share.shareOriginData.link = window.location.href
      ShareConfig.updateShareInfo(this.$store.state.share.shareOriginData)

      // 退出登录时同时清除该缓存信息wechat_auth_status
      let auth = localStorage.getItem("wechat_auth_status")
      /*
      if (auth === "startWechatBind" && to.name === "personalCenter") {
        // 个人中心-》微信绑定
        if (location.href.indexOf("code=") >= 0) {
          let array = location.href.split("code=")
          let lastInfo = array[array.length - 1]
          let code = lastInfo.split("&")[0]
          if (code) {
            CustApi.getWechatBind(code)
              .then((data) => {
                if (data) {
                  localStorage.setItem("wechat_auth_status", "success")
                  this.onGetUserInfo(false)
                }
              })
              .catch((e) => {
                this.$toast(e.msg || e.message)
              })
          }
        }
      } else if (to.name === "home" && auth !== "akeyloginsuccess") {
        // 微信一键登录
        let query = to.query
        if (query && query.loginType === "AKeyLogin") {
          if (location.href.indexOf("code=") >= 0) {
            let array = location.href.split("code=")
            let lastInfo = array[array.length - 1]
            let code = lastInfo.split("&")[0]
            if (code) {
              CustApi.login({ loginType: "PWLTC", loginCode: code })
                .then((data) => {
                  if (data) {
                    localStorage.setItem(
                      "wechat_auth_status",
                      "akeyloginsuccess"
                    )
                    this.setToken(data)
                    this.token = data
                    this.onGetUserInfo(true)
                  }
                })
                .catch((e) => {
                  Dialog.alert({
                    title: "温馨提示",
                    message: e.msg || e.message
                  }).then(() => {
                    // 跳转绑定页面
                    authorize(
                      location.href.split("#")[0] +
                        "#/login/wechatAuthLogin?chanlCode=TA"
                    )
                    // this.$router.replace({ name: "login" })
                  })
                })
            }
          }
        }
      }*/
      if (auth === "phoneAndWechatBindLogin") {
        // 用户手机号登录绑定微信
        if (location.href.indexOf("code=") >= 0) {
          let array = location.href.split("code=")
          let lastInfo = array[array.length - 1]
          let code = lastInfo.split("&")[0]
          if (code) {
            CustApi.getWechatAuth({ code: code })
              .then((data) => {
                this._dismissLoading()
                if (data) {
                  localStorage.setItem("wechat_auth_status", "success")
                  this.onGetUserInfo(false)
                } else {
                  Toast("服务器繁忙, 请稍后再试")
                }
              })
              .catch((e) => {
                this._dismissLoading()
                // this.$toast(e.msg || e.message)
                if (e.code == "1015") {
                  this.loginForm.field.openid = e.data
                  Dialog.alert({
                    title: "温馨提示",
                    message: e.msg || e.message,
                    confirmButtonText: "确定",
                    theme: "round-button"
                  })
                    .then(() => {})
                    .catch(() => {})
                }
              })
          }
        }
      }
      if (this.token) {
        let catchList = JSON.parse(localStorage.getItem("HomeNoticeListKey"))
        let activitys = JSON.parse(localStorage.getItem("activitys"))
        if (
          to.path == "/home" &&
          (!catchList || catchList.length == 0) &&
          (!activitys || activitys.length == 0)
        ) {
          this.loadCustNotice()
        } else {
          this.loadCustNotice()
        }
        this.loadBulletin()
      }
    },
    "userInfo.custId": function (val, old) {
      if (val && val.custId && this.deviceToken) {
        CustApi.editDeviceInfo(this.deviceToken)
      }
    },
    "userInfo.purchaseMayRedPacket": function (val, old) {
      if (val) {
        this.showPurchaseMayRedPacket()
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo", "token", "deviceToken", "channel", "showLuanch"])
  },

  methods: {
    ...mapMutations([
      "setOs",
      "setToken",
      "setDeviceToken",
      "setUserInfo",
      "setPayType",
      "setShowLuanch"
    ]),
    ...mapActions(["getUserInfo"]),
    plusReady() {
      console.info("plusReady")
      document.addEventListener(
        "touchstart",
        function () {
          return false
        },
        true
      )
      this.setOs(plus.os.name.toLowerCase())
      let pinf = plus.push.getClientInfo()
      let cid = pinf.clientid //客户端标识
      if (cid !== "null") {
        this.setDeviceToken(cid)
        if (this.userInfo) {
          CustApi.editDeviceInfo(this.deviceToken)
        }
      }
    },
    onNotify() {
      Notify({
        message: "您已进入天安金交中心",
        color: "#fff",
        background: "#dab866"
      })
    },
    onBack() {
      let first = null
      plus.key.addEventListener(
        "backbutton",
        () => {
          console.info("backbutton")
          if (this.showTabbar) {
            if (!first) {
              first = new Date().getTime()
              plus.nativeUI.toast("再按一次退出应用")
              setTimeout(function () {
                first = null
              }, 1000)
            } else {
              if (new Date().getTime() - first < 1000) {
                plus.runtime.quit()
              }
            }
          } else {
            this.goableBack()
          }
        },
        false
      )
    },
    onGetUserInfo(isAkeyLogin) {
      this.getUserInfo()
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          this.setUserInfo(data)
          if (isAkeyLogin) {
            PayApi.paytype({ chanlCode: this.channel })
              .then((data) => {
                this.setPayType(data)
              })
              .catch((e) => {
                Toast("获取离线支付方式异常")
              })
            this.openLuanch()
          }
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
          this.$router.replace({ name: "login" })
        })
    },
    /**
     * 判断是否有开屏广告
     */
    openLuanch() {
      LuanchApi.loadAd()
        .then((data) => {
          if (data) {
            this.setShowLuanch(true)
          } else {
            this.$router.push({ path: "/home", query: { chanlCode: "TA" } })
          }
        })
        .catch((e) => {
          console.log("app.vue message == %O", e.msg || e.message)
          this.$router.push({ path: "/home", query: { chanlCode: "TA" } })
        })
    },
    showPurchaseMayRedPacket() {
      // 23五月满减券活动期间满30万提示
      this._showTipsInfo(
        "",
        "恭喜您在劳动月活动期间累计认购满30万，再获得3张劳动月满减券！感谢您对天安金交中心的支持与认可。",
        "关闭",
        "前往查看",
        () => {
          mayNoticed().then((data) => {
            this.getUserInfo()
            this.$router.push({ name: "coupon" })
          })
        },
        () => {
          mayNoticed().then((data) => {
            this.getUserInfo()
          })
        }
      )
    },
    loadCustNotice() {
      this.$nextTick(() => {
        getCustNotice()
          .then((data) => {
            if (data.noticeType == 1) {
              this.showRateCouponPop = true
            } else {
              this._showTipsInfo(
                "温馨提示",
                data.contents || "",
                "",
                "好的",
                () => {},
                () => {}
              )
            }
          })
          .catch((e) => {
            console.log(e.msg || e.message)
          })
      })
    },
    onGetRateCoupon() {
      this.$router.push("/invest")
    },
    loadBulletin() {
      let curDate = localStorage.getItem("IS_LOAD_BULLRTIN_KEY")
      let curKey = `${this.userInfo.custAccount.custId}-${this.dateFormat(
        Date.now(),
        "YYYYMMDD"
      )}`
      if (curDate != curKey) {
        console.log("load bulletin")
        // 是否存在反诈骗提示信息
        bulletin()
          .then((data) => {
            localStorage.setItem("IS_LOAD_BULLRTIN_KEY", curKey)
            if (data && data.imgPath) {
              this.adShow = true
              this.imgPath = data.imgPath
            }
          })
          .catch((e) => {
            console.log(e.msg || e.message)
          })
      }
    }
  },
  components: {
    tianTabbar,
    [Dialog.Component.name]: Dialog.Component,
    [Dialog.name]: Dialog,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    luanch,
    RatecouponPop
  }
}
</script>
<style lang="less" scoped>
::v-deep .dialog-privacy {
  .van-dialog__header {
    font-weight: bold;
  }
}
</style>
<style lang="less">
#app {
  min-height: 100vh;
  width: 100vw;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
}
body {
  .van-dialog__confirm,
  .van-dialog__confirm:active {
    color: #df4845;
  }
  .van-toast {
    width: 110px;
    min-height: 110px;
  }
}
</style>
